export default __webpack_public_path__ + "static/media/pragatiKendraExhibition.c519ab30.png";